import { makeStyles } from '@fluentui/react-components';

export const useHiddenComboboxCheckIconStyles = makeStyles({
    hidden: {
        '>.fui-Option__checkIcon': {
            display: 'none',
        },
    },
});
